import React from "react";
import { MoonIcon, SunIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { VnIcon } from "@/components/VnIcon";
import { useAppTheme } from "@/hooks/useAppTheme";

export const ThemeToggle = () => {
  const { theme, setTheme, isDarkMode } = useAppTheme();

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  return (
    <VnButton
      size="icon"
      variant="ghost"
      onPressIn={toggleTheme}
      className="web:focus-visible:ring-3 native:-mt-1 web:ring-offset-background web:transition-colors web:focus-visible:outline-none web:focus-visible:ring-ring bg-background active:opacity-70">
      <VnBox className="flex-1 items-center justify-center">
        <VnIcon as={isDarkMode ? MoonIcon : SunIcon} className="size-5" />
      </VnBox>
    </VnButton>
  );
};
